export default function XIcon({className = ''}: {className?: string}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M6.225 4.811a1.25 1.25 0 0 0-1.414 1.978L9.586 11l-4.775 4.211a1.25 1.25 0 1 0 1.414 1.978L11 12.586l4.211 4.603a1.25 1.25 0 1 0 1.978-1.414L12.414 11l4.603-4.211a1.25 1.25 0 0 0-1.414-1.978L11 9.414 6.225 4.811Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
